import axios from "axios";
import { API_BASE_URL1, API_BASE_URL3 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";
const getToken = () => {
    return localStorage.getItem("token");
  };

  
export const GVPMapViewCountReport = async (filters) => {
  
    const queryParams = new URLSearchParams(filters).toString();
    try {
        // const { StartDate, EndDate,} = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/GvpMapViewReportResult?${queryParams}`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response.data;
    } catch (error) {
        throw error
    }
  };
  export const GVPMapViewReport = async (filters = {}) => {
    
    const queryParams = new URLSearchParams(filters).toString();
    try {
        // const { StartDate, EndDate,} = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/GvpTypeBasedMapViewPointsReports?${queryParams}`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response.data;
    } catch (error) {
        throw error
    }
  };


  export const GVPGeoJSONZoneWise = async () => {
    
    try {
        // const { StartDate, EndDate,} = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllZoneWithGeoJson`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response.data;
    } catch (error) {
        throw error
    }
  };


  export const GVPGeoJSONCircleWise = async (zoneId) => {
    try {
      const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllCirclesWithGeoJson?ZoneId=${zoneId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  